import { type RootContainerProps } from "@client/content/types";
import { type AppState } from "@client/types";
import { connect } from "react-redux";
import Component, { type MapProps } from "./component";
import { localStateSelector } from "./selectors";

const makeMapStateToProps = () => {
  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,
      hasOrder: !!localState.orderSummary
    };
  };
};

export default connect(makeMapStateToProps)(Component);
